<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">To Caroline, and the family she believed in</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thepenaltyarea_00001.vue?3fa0e86a